import CryptoJS from "crypto-js";
import { appFunc, appConfig } from "./FuncHeader";

/* =====================================
   D E F I N I T I O N
   ===================================== */

/* =====================================
   F U N C T I O N S
   ===================================== */

export function validateUserLogin(setConfig = () => {}) 
{
    if (localStorage.getItem(process.env.REACT_APP_API_ACCESS_TOKEN) !== null)
    {
        fetch(process.env.REACT_APP_API_BASE_URL + "/users/verify-user", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem(process.env.REACT_APP_API_ACCESS_TOKEN)
            }
        })
            .then(response => response.json())
            .then(response => {
                // if user's token expire, redirect to user login page. Else, do nothing
                if (response["detail"] === "Could not validate credentials") 
                {
                    clearLocalStorage(setConfig);
                    appFunc.updateUseState.object(appConfig.isUserLogin, false, setConfig);
                }
                else if (response["Authentication"] === "Valid User")
                {
                    appFunc.updateUseState.object(appConfig.isUserLogin, true, setConfig);
                    validateUserAdminStatus(setConfig);
                }
            })
            .catch(error => {
                appFunc.updateUseState.object(appConfig.isUserLogin, false, setConfig)
                console.error(error);
            });
    }
    else 
    {
        appFunc.updateUseState.object(appConfig.isUserLogin, false, setConfig)
    }
}

export function IsAccountActive(navigate) {
    if (localStorage.getItem(process.env.REACT_APP_API_ACCESS_TOKEN) !== null) {
        navigate("/", { replace: true });
    }
}

export function encryptText(textVal) {
    let iv = CryptoJS.lib.WordArray.random(16);
    let encryptedData = CryptoJS.AES.encrypt(textVal, CryptoJS.enc.Base64.parse("582fd0bf686c7520fc4d0c7d94298cce"), { iv: iv });
    let joinedData = iv.clone().concat(encryptedData.ciphertext);
    return CryptoJS.enc.Base64.stringify(joinedData);
}

export function clearLocalStorage(setConfig = () => {}) {
    localStorage.removeItem(process.env.REACT_APP_API_ACCESS_TOKEN);
    localStorage.removeItem(process.env.REACT_APP_API_USER_DISPLAY_NAME);
    appFunc.updateUseState.object(appConfig.isUserLogin, false, setConfig);
    appFunc.updateUseState.object(appConfig.isUserAdmin, false, setConfig);
}


export function validateUserAdminStatus(setConfig = () => {}) {
    let token = localStorage.getItem(process.env.REACT_APP_API_ACCESS_TOKEN);
    fetch( process.env.REACT_APP_API_BASE_URL + "/users/verify-admin", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + token
        }
    })
    .then(response => response.json())
    .then(response => {
        if (response["Success"] !== undefined)
        {
            let resVal = response["Success"]["adminStatus"];
            appFunc.updateUseState.object(appConfig.isUserAdmin, resVal === "1" || resVal === 1, setConfig);
        }
        else if (response["Error"] !== undefined)
        {
            console.log(response["Error"]);
        }
    })
    .catch(error => console.error(error));
}